import { getFormattedValue, unprocessScaleType } from "../../../lib/utils.js";
import { MSColorPicker } from '../../colorpicker/colorpicker.js';
import { UiFloatModal } from '../../common/modal/index.js'
import styles from './legend.css'


const selectedIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="19" height="13" viewBox="0 0 19 13" fill="none">
<path d="M9.5 9.48324C10.522 9.48324 11.3892 9.15156 12.1017 8.48821C12.8142 7.82486 13.1705 7.01745 13.1705 6.06598C13.1705 5.11451 12.8142 4.3071 12.1017 3.64375C11.3892 2.9804 10.522 2.64872 9.5 2.64872C8.47803 2.64872 7.6108 2.9804 6.8983 3.64375C6.1858 4.3071 5.82955 5.11451 5.82955 6.06598C5.82955 7.01745 6.1858 7.82486 6.8983 8.48821C7.6108 9.15156 8.47803 9.48324 9.5 9.48324ZM9.5 8.31735C8.82348 8.31735 8.25133 8.09958 7.78352 7.66405C7.31572 7.22852 7.08182 6.69583 7.08182 6.06598C7.08182 5.43613 7.31572 4.90344 7.78352 4.46791C8.25133 4.03238 8.82348 3.81461 9.5 3.81461C10.1765 3.81461 10.7487 4.03238 11.2165 4.46791C11.6843 4.90344 11.9182 5.43613 11.9182 6.06598C11.9182 6.69583 11.6843 7.22852 11.2165 7.66405C10.7487 8.09958 10.1765 8.31735 9.5 8.31735ZM9.5 12.0964C7.39848 12.0964 5.49849 11.5403 3.8 10.428C2.10152 9.31573 0.834848 7.86172 0 6.06598C0.834848 4.27024 2.10152 2.81623 3.8 1.70395C5.49849 0.591664 7.39848 0.0355225 9.5 0.0355225C11.6015 0.0355225 13.5015 0.591664 15.2 1.70395C16.8985 2.81623 18.1652 4.27024 19 6.06598C18.1652 7.86172 16.8985 9.31573 15.2 10.428C13.5015 11.5403 11.6015 12.0964 9.5 12.0964ZM9.5 10.8903C11.2417 10.8903 12.843 10.4515 14.304 9.5737C15.765 8.69593 16.8769 7.52669 17.6398 6.06598C16.8769 4.60527 15.765 3.43603 14.304 2.55826C12.843 1.6805 11.2417 1.24161 9.5 1.24161C7.75833 1.24161 6.15701 1.6805 4.69602 2.55826C3.23504 3.43603 2.11591 4.60527 1.33864 6.06598C2.11591 7.52669 3.23504 8.69593 4.69602 9.5737C6.15701 10.4515 7.75833 10.8903 9.5 10.8903Z" fill="black"/>
</svg>
`

const arrowIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
<path d="M9.99769 -1.03968e-06L10.9814 0.91166L5.49074 6L3.01835e-05 0.932861L0.983783 0.0211993L5.49074 4.19788L9.99769 -1.03968e-06Z" fill="black"/>
</svg>
`

const template = `
    <style>
        ${styles}
    </style>
    <table class="trend-legend" id="trend-legend">
        <tbody id="trend-legend-body"></tbody>
    </table>
    <ul class="groups-wrapper" id="groups-wrapper"></ul>
`

const groupTemplate = (group, active, color) => `
    <table class="trend-legend active" id="trend-legend">
        <thead class="group-label-wrap" id="group-label-wrap">
            <tr>
                <td class="group-pen-visible ${active ? "active" : ""}" id="group-visible-${group.name}">${selectedIcon}</td>
                <td class="group-color" style="background: ${color}" id="group-color-${group.name}"></td>
                <td class="group-pen-name" id="group-name">
                    ${group.name}
                </td>
                <td class="group-pen-arrow" id="group-arrow">
                    <div>${arrowIcon}</div>
                </td>
            </tr>
        </thead>
        <tbody class="group-list-wrap" id="group-list-wrap"></tbody>
    </table>
`

const groupPenTemplate = (name, active, color, value) =>{
return `
    <tr class="group-pen-wrap" id="group-pen-wrap">
        <td class="group-pen-visible ${active ? 'active' : ''}" id="group-pen-visible">${selectedIcon}</td>
        <td class="color-group ${active ? 'active' : ''}"><ms-colorpicker id="color" style="border-radius: 0; position: relative; width: 5px; height: 27px" colorselect="${color}"></ms-colorpicker></td>
        <td class="group-pen-name" id="group-pen-name">${name}</td>
        <td class="group-pen-value" id="group-pen-value">${value}</td>
    </tr>
`}

/**
 * @class MSMiniLegend
 * @extends Basic
 * @classdesc Минилегенда
 * */
export class Legend {
    constructor(root) {
        this.root = root
        this.root.checkComponent('ms-colorpicker', MSColorPicker)
        this.initPopup()
        this.generateGroups()
    }

    generateGroups() {
        let free = []
        let groups = {}
        for (let i = 0; i < this.root.pens.length; i++) {
            const pen = this.root.pens[i]
            const value = { 
                source: pen.source, 
                name: pen.name, 
                color: pen.color, 
                active: pen.isvisible, 
                value: pen.lastValue ? pen.lastValue[1] : null, 
                logscale: pen.logscale,
                yformat: pen.yformat,
                groupname: pen.groupname, 
                unit: pen.unit,
                index: pen.idx 
            }
            if (pen.groupname) {
                if (!(pen.groupname in groups)) groups[pen.groupname] = { name: pen.groupname, pens: [], selected: true }
                groups[pen.groupname].pens.push(value)
            } else free.push(value)
        }
        for (var key in groups) {
            this.root.trendGroups?.groups?.forEach((group) => {
                if(group.name === key){
                    groups[key].color = group.yAxis.nameTextStyle.color
                }
            })
            groups[key].isActive = !!groups[key].pens.filter((pen) => pen.active === true).length
        }
        this.free = free
        this.groups = groups
    }

    renderPens(values, element = this.pensWrap) {
        if (!element) return
        for (let i = 0; i < values.length; i++) {
            const pen = values[i]
            const rPen = this.pens.find(p => p.source === pen.source)
            const tr = document.createElement('tr')
            tr.classList.add('pen-row')
            tr.setAttribute('group', false)
            const { name, active, color, value, yformat, logscale, unit} = pen
            if (this.root.currentPen === pen.index) tr.classList.add('active')
            const lastValue = this.formationLastValue(value, yformat, logscale, unit)
            tr.innerHTML = groupPenTemplate(name, active, color, lastValue)
            rPen.activeEl = tr.querySelector('#group-pen-visible')
            rPen.colorEl = tr.querySelector('#color')
            rPen.nameEl = tr.querySelector('#group-pen-name')
            rPen.valueEl = tr.querySelector('#group-pen-value')
            rPen.elem = tr
            element.appendChild(tr)
            this.initPenHandlers(rPen)
        }
    }

    
    formationLastValue(value, yformat, logscale, unit){
        switch(typeof value){
            case "number":
                return `${getFormattedValue(yformat, unprocessScaleType(value, logscale))}${unit != undefined && ` ${unit}`}`
            case "boolean":
                return `${value}`
            default:
                return 'Неопределено'
        }
    }

    initPenHandlers(pen) {
        pen.elem.addEventListener('click', this.onSelectMinilegend.bind(this, pen.index))
        pen.activeEl.addEventListener('click', this.onCheckbox.call(this, pen.index))
        pen.colorEl.onColorChange = this.onColor.call(this, pen.index)
    }

    renderGroups() {
        for (const key in this.groups) {
            const group = this.groups[key]
            const li = document.createElement('li')
            li.setAttribute('Id', group.id)
            li.setAttribute('group', true)
            li.innerHTML = groupTemplate(group, group.isActive, group.color)
            const headerVisible = li.querySelector(`.group-pen-visible`)
            headerVisible.addEventListener('click', this.onCheckboxGroup.call(this, group, headerVisible))
            const tbody = li.querySelector('#group-list-wrap')
            this.renderPens(group.pens, tbody)
            this.groupsWrap.appendChild(li)
            const element = li.querySelector('#trend-legend')
            this.initGroupHandlers(element)
        }
    }

    initGroupHandlers(element) {
        const header = element.querySelector('#group-label-wrap')
        header.addEventListener('click', this.toggleGroup.call(this, header, element))
    }

    onCheckboxGroup(group, element) {
        return (e) => {
            group.isActive = !group.isActive
            const pens = []
            group.pens.forEach(pen => {
                pens.push(this.pens[pen.index])
            })
            pens.forEach(pen => {
                pen.isvisible = group.isActive
                this.root.pens[pen.index].isvisible = pen.isvisible
                this.root.setScope()
                if (pen?.activeEl) {
                    if(pen.isvisible){
                        pen.activeEl.classList.add('active')
                    } else {
                        pen.activeEl.classList.remove('active')
                    }
                }
            })
            if(group.isActive){
                element.classList.add('active')
            } else {
                element.classList.remove('active')
            }

        }
    }

    toggleGroup(header, table) {
        return (e) => {
            const li = e.target.closest('td')
            if (li.id !== 'group-arrow' && li.id !== 'group-name') return
            header.classList.toggle('active')
            table.classList.toggle('active')
        }
    }

    createPens() {
        this.pens = []
        const pens = this.root.pens
        pens.forEach((({ color, name, lastvalue, isvisible, source, groupname, mainpengroup, idx, unit, selected }) => {
            this.pens.push({ color, name, lastvalue, isvisible, source, groupname, mainpengroup, index: idx, unit, isselected: Boolean(selected) })
        }))
    }
    initPopup() {
        this.popup = new UiFloatModal(template)
        this.popup.modalComponent.classList.innerHTML += styles
        this.pensWrap = this.popup.modalComponent.querySelector('#trend-legend-body')
        this.groupsWrap = this.popup.modalComponent.querySelector('#groups-wrapper')
        this.popup.modalComponent.calculateInitialPosition = () => {
            const { top, right } = this.root.getBoundingClientRect()
            // 10 - это дополнительный отступ, чтобы не прилипало к верху
            return [right - this.popup.modalComponent.offsetWidth, top + this.root.toolbar.offsetHeight + 10]
        }
        this.popup.modalComponent.changeActive = (value) => {
            this.root.toolbar.setToggleState(this.root.toolbar.elements["ShowLegend"], value);
        }
    }

    render() {
        this.clearLegend()
        this.createPens()
        this.generateGroups()
        this.pensWrap.innerHTML = ''
        this.groupsWrap.innerHTML = ''
        this.renderPens(this.free, this.pensWrap)
        this.renderGroups()
        const label = `${i18next.t('trend_legend_titleMinilegend')} ${this.root.trendGroup?.group ? `- ${this.root.trendGroup?.group.name}` : ''}`
        this.popup.modalComponent.label = label
    }

    toggle(value) {
        if (!this.popup) this.initPopup();
        if(value){
            this.popup.modalComponent.open()
            this.render()
        } else {
            this.popup.modalComponent.close()
        }
        this.root.toolbar.setToggleState(this.root.toolbar.elements["ShowLegend"], this.popup.modalComponent.active);
    }



    clearLegend(){
        this.pens?.forEach(pen => {
            pen?.elem?.removeEventListener('click', this.onSelectMinilegend.bind(this, pen.index));
            pen?.activeEl?.removeEventListener('click', this.onCheckbox.call(this, pen.index));
        });

        this.pens?.forEach(pen => {
            if(pen.activeEl) pen.activeEl = null;
            if(pen.colorEl) pen.colorEl = null;
            if(pen.nameEl) pen.nameEl = null;
            if(pen.valueEl) pen.valueEl = null;
            if(pen.elem) pen.elem = null;
        });

        for (const key in this.groups) {
            const group = this.groups[key];
            const li = document.getElementById(group.id);
            if(!li) continue
            const headerVisible = li.querySelector(`.group-pen-visible`);
            headerVisible.removeEventListener('click', this.onCheckboxGroup.call(this, group, headerVisible));
        }
    }

    destroy() {
        this.clearLegend()
        
        if (this.popup) {
            this.popup.modalComponent.delete()
            this.popup = null;
        }


        this.root = null;
        this.pens = null;
        this.groups = null;
        this.free = null;
    }

    onCheckbox(index) {
        return (e) => {
            const pen = this.pens[index]
            pen.isvisible = !pen.isvisible
            this.root.pens[index].isvisible = pen.isvisible
            this.root.setScope()
            if (pen?.activeEl) {
                if(pen.isvisible){
                    pen.activeEl.classList.add('active')
                } else {
                    pen.activeEl.classList.remove('active')
                }
            }
            if(pen.groupname){
                const groupname = pen.groupname
                let isActive = false;
                this.pens.forEach(pen => {
                    if(pen.groupname === groupname){
                        if(pen.isvisible){
                            isActive = true
                        }
                    }
                })
                if(isActive !== this.groups[pen.groupname].isActive){
                    this.groups[pen.groupname].isActive = isActive
                    const element = document.getElementById(`group-visible-${groupname}`)
                    if(isActive){
                        element.classList.add('active')
                    } else {
                        element.classList.remove('active')
                    }
                }
            }
        }
    }

    onColor(index) {
        return (e, color) => {
            this.root.pens[index].color = color
            if (this.root.tableLegend) this.root.tableLegend._reciver()
            if(this.pens[index]){
                const pen = this.pens[index]
                if (pen.colorEl) {
                    const elem = this.pens[index].colorEl
                    elem.colorselect = color
                }
                if(pen.mainpengroup){
                    const element = this.popup.modalComponent.querySelector(`#group-color-${pen.groupname}`)
                    element.style.background = color   
                }
                this.root?.trendGroups?.reinit()
            }
            this.root.echarts.setOption({ series: this.root.pens.series });
        }
    }

    getOptionTRN() {
        return (
            $sw.serverState.currentState.features == null ||
            ($sw.serverState.currentState.features & 0x800) != 0
        );
    }

    /**
    * Создать минилегенду в SVG (для сохранения изображения и отправки на печать)
    * @return {HTMLElement} svg
    * */
    createSVG() {
        let table = document.createElement("g");
        let maxlength = 0;
        let maxUnitlength = 0;
        const gap = 20;
        this.pens.forEach((_, i) => {
            if (this.getName(i).length > maxlength){
                maxlength = this.getName(i).length;
            }
            if (this.getUnit(i).length > maxUnitlength){
                maxUnitlength = this.getUnit(i).length;
            }
        });
        for (let i = 0; i < this.pens.length; i++) {
            if (this.pens[i].isvisible) {
                table.innerHTML += `
                <text x='5' y='${15 + i * 20}' font-size='small'>${this.getName(
                    i
                )}</text>
                <text x='${maxlength * 8 + gap}' y='${15 + i * 20}' font-size='small'>${this.getUnit(
                    i
                )}</text>
                <rect x=${maxlength * 8 + maxUnitlength * 8 + gap * 2} y='${1 + i * 20
                    }' width='40' height='18' fill='${this.getColor(i)}'/>`;
            }
        }
        return table;
    }

    /**
     * Получить имя пера
     * @param {number} k номер пера в массиве перьев
     * @return {string} имя пера
    */
    getName(k) {
        return this.pens[k].name;
    }

    getUnit(k) {
        return this.pens[k].unit;
    }

    onSelectMinilegend(index, e){
        let currentElement = e.target;
        const targetClasses = ['group-pen-visible', 'color-group']

        while (!currentElement.classList?.contains('pen-row')) {
            if (currentElement.classList && targetClasses.some(cls => currentElement.classList?.contains(cls))) {
                return
            }
            currentElement = currentElement.parentElement;
        }
        this.root.selectPen(index)
    }

    updateSelect(){
        this.pens.forEach((pen, i) => {
            pen.elem?.classList.remove("active")
            if (i == this.root.currentPen) {
                if (pen?.elem) {
                    if (pen.elem) pen.elem.classList.add('active')
                }
            }
        });
    }

    // для дискретного тренда
    setColor(index, color) {
        this.pens[index].color = color
        if (this.root.tableLegend) this.root.tableLegend._reciver()
        if (this.pens[index].colorEl) {
            const elem = this.pens[index].colorEl
            elem.colorselect = color
        }
    }

    /**
     * Установить последнее значение пера
     * @param {number} k номер пера в массиве перьев
     * @param {number} value последнее значение
     */
    setLastValue(k, value, yformat, unit, logscale) {
        const val = this.formationLastValue(value, yformat, logscale, unit)
        if (this.pens[k]?.valueEl) {
            const elem = this.pens[k].valueEl
            elem.innerHTML = val
        }
        this.pens[k].lastvalue = val;
    }

    getColor(k) {
        return this.pens[k].color;
    }

    setOpacity(value){
        if(this.popup) this.popup.modalComponent.style.opacity = value
    }
}
